import { Marks } from 'rc-slider';

export interface SliderElement {
  value: number | string;
  label: JSX.Element | string | { style: any; label: string | JSX.Element };
}

export const generateRangeMapping = (
  increments: (string | number)[],
  ticks: (string | number)[],
  cb?: (
    increment: string | number
  ) => JSX.Element | string | { style: any; label: string | JSX.Element }
  // The result of the callback should match the value signature of the Marks interface from rc-slider -sw 6/26/19
): SliderElement[] =>
  increments.reduce((memo: SliderElement[], increment: string | number): SliderElement[] => {
    const newSliderElement: SliderElement = { value: increment, label: '' };
    if (ticks.includes(increment)) {
      newSliderElement.label = cb ? cb(increment) : `${increment}`;
    }
    return [...memo, newSliderElement];
  }, []);

export const generateMarks = (
  mapping: SliderElement[]
): {
  [key: number]:
    | string
    | JSX.Element
    | {
        style: any;
        label: string | JSX.Element;
      };
} =>
  mapping.reduce((acc: Marks, { label }, idx): Marks => {
    return { ...acc, [idx]: label };
  }, {});

export const getRangeMappedValue = (
  mapping: SliderElement[],
  indexes: [number, number]
): [number | string, number | string] =>
  indexes.map((index: number): number | string => {
    if (index === 0 || index === mapping.length - 1) {
      return '';
    }
    // this is done to address how we handle ambiguous ranges like "_10" and "0_" -sw 8/2/19
    return mapping[index].value;
  }) as [number | string, number | string];

export const getMappedValue = (mapping: SliderElement[], index: number): number | string =>
  mapping[index].value;

export const getTooltipValue = (mapping: SliderElement[], index: number): string =>
  String(mapping[index].value);

// getRangeValueFromParams and getSingleValueFromParams populates values from the query (if any) to the filters -sw 7/12/19

export const getRangeValueFromParams = (
  paramFilter: string | string[] | undefined,
  increments: (number | string)[]
): number[] => {
  let defaultValues = [0, increments.length - 1];

  if (paramFilter && typeof paramFilter === 'string') {
    const paramValues = paramFilter.split('_');

    defaultValues = paramValues.map((val, idx): number => {
      const isNumber = !Number.isNaN(Number.parseInt(val, 10));
      if (val.length) {
        if (isNumber) {
          return increments.indexOf(Number.parseInt(val, 10));
        } else {
          return increments.indexOf(val);
        }
      }
      return defaultValues[idx];
    });
  }

  return defaultValues;
};

export const getSingleValueFromParams = (
  value: string | string[] | undefined,
  increments: (number | string)[]
): number | undefined => {
  let defaultValue = 0;

  if (value && typeof value === 'string') {
    const isNumber = !Number.isNaN(Number.parseInt(value));

    if (value.length) {
      if (isNumber) {
        defaultValue = increments.indexOf(Number.parseInt(value));
      } else {
        defaultValue = increments.indexOf(value);
      }
    }
    return defaultValue;
  }

  return undefined;
};
